import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import { Subscription } from 'rxjs';
import { FormAllFieldsValidationService } from '../../../../shared/services/form-all-fields-validation.service';
import { GetItemListFieldsService, } from '../../../../shared/services/get-item-list-fields.service';
import {
  ApproveRequest,
  ApproveService
} from '../../../services/approve.service';
import { Transfer } from '../../../services/payment-details.service';

@Component({
  selector: 'ab-validate-payment',
  templateUrl: './validate-payment.component.html',
  styleUrls: ['./validate-payment.component.scss']
})
export class ValidatePaymentComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @Input() transfer: Transfer;
  @Input() challengeCode: string;
  @Input() selectedAccountNumber: string;
  @Input() selectedReferenceCode: string;
  @Input() dialogRef: MatDialogRef<any>;
  @Output() cancelPayment = new EventEmitter();
  @Output() setMerchantInfo = new EventEmitter();
  @Output() setPaymentStatus = new EventEmitter();
  @ViewChild('approvalCodeInput') approvalCodeInput: ElementRef;

  public isLoading = false;
  public isSubmittingConfirm = false;
  public items: any;
  public approvalCodeErrorMessage: string;
  public confirmPaymentForm = new UntypedFormGroup({
    approvalCode: new UntypedFormControl(null, [
      Validators.required,
      Validators.pattern('[0-9]+')
    ])
  });

  private subscriptions: Subscription[] = [];

  constructor(
    private approveService: ApproveService,
    private formAllFieldsValidationService: FormAllFieldsValidationService,
    private getItemListFieldsService: GetItemListFieldsService
  ) {}

  get approvalCode() {
    return this.confirmPaymentForm.get('approvalCode');
  }

  @HostListener('document:keypress', ['$event'])
  onEnterPress(event) {
    if (event.key === 'Enter' && this.confirmPaymentForm.valid) {
      this.submitPayment();
      this.approvalCodeInput.nativeElement.blur();
    }
  }

  ngOnInit(): void {
    this.items = this.getItemListFieldsService.getItems(
      this.rendering?.fields?.items as Item[]
    );

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  openCancelPaymentPopup() {
    this.cancelPayment.emit('trigger');
  }

  submitPayment() {
    const approveTransferRequest: ApproveRequest = {
      challengeCode: this.challengeCode,
      signature: this.confirmPaymentForm?.get('approvalCode')?.value
    };

    this.formAllFieldsValidationService.validationAllForms(
      this.confirmPaymentForm
    );

    if (!this.confirmPaymentForm.valid) {
      return;
    }

    this.isSubmittingConfirm = true;
    this.subscriptions.push(
      this.approveService.approveTransfer(approveTransferRequest).subscribe({
        next: (approveResponse: any) => {
          this.isSubmittingConfirm = false;
          if (approveResponse.callIsSuccess) {
            this.setMerchantInfo.emit(approveResponse);
            if (this.dialogRef) {
              this.dialogRef.close();
            }
          } else {
            this.approvalCodeErrorMessage = approveResponse.errorDescription;
            this.confirmPaymentForm.get('approvalCode')?.setErrors({
              approvalCodeError: true
            });
          }
        },
        error: (error: any) => {
          this.confirmPaymentForm.get('approvalCode')?.setErrors({
            approvalCodeError: true
          });
        }
      })
    );
  }
}
